import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = { "data-id": "dialog-title" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2px"
}
const _hoisted_3 = { class: "absolute right-0 top-0" }
const _hoisted_4 = { class: "dialog-card-action-buttons px-5 pt-2 pb-10" }

import { PropType, computed, ref } from 'vue'
import notify from '../plugins/notify'
import dialog from '../plugins/dialog'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: Boolean,
  title: {
    type: String,
    default: '',
  },
  isDirty: {
    type: Boolean,
    default: undefined,
  },
  disableConfirm: Boolean,
  disabledConfirmTooltip: {
    type: String,
    default: undefined,
  },
  confirmButtonText: {
    type: String,
    default: undefined,
  },
  cancelButtonText: {
    type: String,
    default: undefined,
  },
  hideConfirmButton: Boolean,
  hideCancelButton: Boolean,
  ignoreDirtyCheckOnConfirm: Boolean,
  isLoading: Boolean,
  confirmCancelTitle: {
    type: String,
    default: undefined,
  },
  confirmCancelMessage: {
    type: String,
    default: undefined,
  },
  maxWidth: {
    type: [String, Number],
    default: '100%',
  },
  contentClass: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: undefined,
  },
  position: {
    type: String as PropType<'top' | 'standard' | 'right' | 'bottom' | 'left' | undefined>,
    default: 'top',
  },
},
  emits: [
  'confirm',
  'cancel',
],
  setup(__props, { expose, emit }) {

const props = __props

const { t } = useI18n()





// State etc.
const confirmIsDisabled = computed(() => {
  return (
    props.disableConfirm ||
    props.isLoading ||
    (!props.ignoreDirtyCheckOnConfirm && props.isDirty === false)
  )
})
const dialogForm = ref()

// Functions
function cancel () {
  if (props.isDirty) {
    dialog.confirm({
      title: props.confirmCancelTitle || t('inri.dialog.unsaved_changes_title'),
      text: props.confirmCancelMessage || t('inri.dialog.unsaved_changes_message'),
    }).onOk(() => {
      emit('cancel')
    })
  } else {
    emit('cancel')
  }
}

function confirm () {
  if (!props.disableConfirm) {
    dialogForm.value.validate().then(success => {
      if (success) {
        emit('confirm')
      }
    })
  } else {
    notify.error(props.disabledConfirmTooltip || t('inri.dialog.confirm_tooltip_invalid_fields'))
  }
}

// So that we can trigger confirm/cancel from a component ref
expose({
  confirm,
  cancel,
})

return (_ctx: any,_cache: any) => {
  const _component_c_dirty_check = _resolveComponent("c-dirty-check")!
  const _component_c_dialog_close_btn = _resolveComponent("c-dialog-close-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_c_btn = _resolveComponent("c-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_c_spinner = _resolveComponent("c-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "data-id": "dialog",
    class: "c-dialog",
    "model-value": __props.modelValue,
    position: __props.position,
    "transition-show": "fade",
    "transition-hide": "fade",
    "no-refocus": "",
    "onUpdate:modelValue": cancel,
    onKeydown: _withKeys(_withModifiers(confirm, ["ctrl","prevent"]), ["s"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_c_dirty_check, {
        "is-dirty": __props.isDirty,
        "is-dialog-open": __props.modelValue
      }, null, 8, ["is-dirty", "is-dialog-open"]),
      _createVNode(_component_q_card, {
        class: "dialog-card",
        style: _normalizeStyle({ maxWidth: __props.maxWidth ? __props.maxWidth : false })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            ref_key: "dialogForm",
            ref: dialogForm,
            greedy: "",
            class: "flex flex-col flex-nowrap max-h-full",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "px-5 pt-6 pb-4" }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(__props.title), 1)
                  ]),
                  (__props.text)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.text), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "corner-buttons"),
                    _createVNode(_component_c_dialog_close_btn, { onClick: cancel })
                  ])
                ]),
                _: 3
              }),
              (_ctx.$slots.default)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    class: _normalizeClass(["px-5 pb-4 overflow-y-overlay flex-1", __props.contentClass])
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (!__props.hideConfirmButton)
                  ? (_openBlock(), _createBlock(_component_c_btn, {
                      key: 0,
                      "data-id": "dialog-confirm-button",
                      label: __props.confirmButtonText || _ctx.$t('inri.common.confirm'),
                      disabled: _unref(confirmIsDisabled),
                      onClick: confirm
                    }, {
                      default: _withCtx(() => [
                        (_unref(confirmIsDisabled))
                          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.disabledConfirmTooltip || _ctx.$t('inri.dialog.confirm_tooltip_invalid_fields')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["label", "disabled"]))
                  : _createCommentVNode("", true),
                (!__props.hideCancelButton)
                  ? (_openBlock(), _createBlock(_component_c_btn, {
                      key: 1,
                      "data-id": "dialog-cancel-button",
                      label: __props.cancelButtonText || _ctx.$t('inri.common.cancel'),
                      color: "surface",
                      onClick: cancel
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 3
          }, 512),
          _createVNode(_component_q_inner_loading, { showing: __props.isLoading }, {
            default: _withCtx(() => [
              _createVNode(_component_c_spinner)
            ]),
            _: 1
          }, 8, ["showing"])
        ]),
        _: 3
      }, 8, ["style"])
    ]),
    _: 3
  }, 8, ["model-value", "position", "onKeydown"]))
}
}

})